var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kustomer-header",staticStyle:{"padding":"8px 0px 4px !important"}},[_c('div',{staticClass:"kustomer-logo"},[_vm._t("logo")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }